export enum NotesTypesEnum {
  ANNOUNCEMENT = "Announcement",
  PATCH_NOTE = "Patch Note",
}

export enum NoteCategories {
  EXTERNAL_NOTE = "ekstern_note",
  PDF_NOTE = "pdf_note",
}
